/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import getCountries from '../api/countries';

const useCountries = () => {
  const [countries, setCountries] = useState<{ value: string; label: string }[]>([]);
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const { t } = useTranslation();

  const {
    refetch: fetchData,
    data: dataCountries,
    isLoading,
  } = useQuery('countries', getCountries, {
    onSuccess: () => setShowAlertMessage(false),
    onError: (err: any) => {
      if ((err as any)?.code === 401) return;
      Sentry.captureException(new Error('Error fetching countries'), {
        extra: { error: JSON.stringify(err) },
      });
      setShowAlertMessage(true);
    },
  });

  useEffect(() => {
    if (dataCountries) {
      setCountries(
        dataCountries.map((country: { isoCode2: string; name: string }) => ({
          value: country.isoCode2,
          label: t([`countries.${country.isoCode2}`, `countries.${country.name}`, country.name]),
        }))
      );
    }
  }, [dataCountries]);

  return { countries, fetchData, isLoading, showAlertMessage };
};

export default useCountries;
